<script setup lang="ts">
import { computed } from 'vue'
import { Sun, Moon } from 'lucide-vue-next'
import { useThemeStore } from '../../stores/theme'

const themeStore = useThemeStore()
// Setup-store refs are auto-unwrapped on the store instance.
const isDarkMode = computed(() => themeStore.theme === 'dark')

const toggleTheme = () => {
  themeStore.toggleTheme()
}
</script>

<template>
  <button
    @click="toggleTheme"
    type="button"
    class="inline-flex items-center justify-center size-9 rounded-lg text-blue-100 hover:text-white hover:bg-white/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mlb-gold/60"
    :aria-label="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
  >
    <Sun v-if="isDarkMode" class="w-[18px] h-[18px] text-mlb-gold-light" />
    <Moon v-else class="w-[18px] h-[18px]" />
  </button>
</template>
